export function getSourceIconUrl(
  sourceId: string,
  icon: string | null | undefined
): string | undefined {
  if (!icon) return undefined;
  const baseUrl = import.meta.env.VITE_API_URL || 'http://localhost:3000';
  return `${baseUrl}/public/source-icons/${sourceId}`;
}
